import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import metadata from '../seo-metadata.json';

function normalizeSiteUrl(url) {
  if (!url) return '';
  // remove protocol for simpler checks, then restore https
  let u = url.trim();
  u = u.replace(/https?:\/\//i, '');
  // remove www. prefix
  u = u.replace(/^www\./i, '');
  // remove trailing slash
  u = u.replace(/\/$/, '');
  return `https://${u}`;
}

const SITE_URL = normalizeSiteUrl(process.env.REACT_APP_SITE_URL) || 'https://securxperts.com';

function humanizePath(pathname) {
  if (!pathname || pathname === '/') return 'Home';
  return pathname
    .replace(/^\//, '')
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function SEO({ title, description, canonical: canonicalProp, includeQueryString = false }) {
  const { pathname, search } = useLocation();
  const base = SITE_URL.replace(/\/$/, '');
  const autoCanonical = `${base}${pathname}` + (includeQueryString && search ? search : '');
  const canonical = canonicalProp || autoCanonical;

  // Resolve metadata: explicit prop > mapping > auto-generated
  const meta = metadata[pathname] || {};
  const finalTitle = title || meta.title || `${humanizePath(pathname)} — SecurXperts`;
  const finalDesc = description || meta.description || 'SecurXperts — software, cloud and cybersecurity services.';

  return (
    <Helmet>
      {finalTitle && <title>{finalTitle}</title>}
      {finalDesc && <meta name="description" content={finalDesc} />}
      <link rel="canonical" href={canonical} />
      <meta property="og:url" content={canonical} />
    </Helmet>
  );
}
